import { Loader } from './Loader';

/**
 * What a route shows while its chunk downloads or while auth resolves. Fades
 * in after a beat so a chunk that arrives from cache never flashes a spinner.
 */
export default function RouteFallback({ full = false }: { full?: boolean }) {
  return (
    <div
      className={`fade-in-late flex items-center justify-center text-mint-300 ${
        full ? 'min-h-dvh' : 'py-24'
      }`}
    >
      <Loader />
    </div>
  );
}
